export default {
  parameters: {
    landing_id: "InQOw",
  },
  downtimeUrl: "https://id6.kodland.tech",
  ageRules: {
    min: 5,
    max: 17,
  },
  title: "Dari Ide ke Website & Desain Digital | Kodland",
  startPage: {
    title: "Jawablah 5 pertanyaan dan dapatkan pelajaran GRATIS untuk anak anda",
    button: "Terima 🚀",
    subtitle: "Daftar kelas gratis",
    image: {
      url: "/welcome/in_fwd_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/in_fwd_mob.png",
      style: {
        width: "100%",
      },
    },
  },
  successPage: {
    title: "Pilih tanggal dan waktu untuk mendapatkan pelajaran GRATIS 🚀",
    subtitle: "Klik tombol “📆 Pesan” dan dapatkan pelajarannya.",
    button: "📆 Pesan",
  },
  stopPage: {
    image: "/welcome/quiz_stop_page.jpg",
    title: "Terima kasih karena sudah mempercayakan kami sebagai platform edukasi Anda! Sayangnya, tablet atau handphone tidak dapat digunakan untuk mengikuti pembelajaran kami. Dengan senang hati kami akan menantikan kehadiran Anda kembali di kelas!",
  },
  quizRotateBySteps: {
    1: {
      question: "Bagaimana biasanya anak Anda menghabiskan waktu luangnya?",
      answers: [
        "📱 Bermain game di HP atau komputer",
        "👽 Menonton kartun",
        "🙌 Bermain permainan papan",
        "😌 Menghabiskan waktunya dengan keluarga",
        "👥 Menghabiskan waktunya dengan teman",
        "⛹️ Bermain kegiatan olahraga",
        "🎨 Melakukan aktivitas seni: menggambar, musik, akting, dsb.",
      ],
    },
    2: {
      question: "Apakah anak Anda mengikuti kegiatan ekstrakurikuler di luar pembelajaran sekolah?",
      answers: [
        "📚 Kelas yang membantu untuk meningkatkan nilai pembelajara",
        "⛹️ Ya. Kegiatan olahraga",
        "🎨 Ya. Kelas seni",
        "💻 Ya. Kelas koding dan ilmu komputer",
        "🏕️ Ya. Pramuka",
        "✖️ Tidak. Anak tidak memiliki waktu untuk itu",
      ],
    },
    3: {
      question:
        "Untuk mengikuti kelas gratis ini, Anda perlu menggunakan komputer atau laptop (bukan HP) dengan koneksi internet stabil. Apakah Anda memiliki komputer/laptop di rumah?",
      answers: [
        "💻 Ya, kami memiliki komputer/laptop di rumah",
        {
          answer: "❌ Tidak, kami tidak memiliki komputer/laptop di rumah",
          stopAnswer: true,
        },
      ],
    },
  },
};
